import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter, Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* <HashRouter> */}
      {/* </HashRouter> */}
    </Provider>
  // </React.StrictMode>
);

// Optional performance monitoring
reportWebVitals();